module.exports = __webpack_public_path__ + "img/roundedfilter.24d3997a.svg";